'use client';

import { useMutation } from '@tanstack/react-query';

import { fetchEmailAuthHint } from '../lib/email-auth-hint-client';
import type { EmailAuthHint } from '../lib/email-auth-hint-client';

export type { EmailAuthHint };

/**
 * @name useEmailAuthHint
 * @description
 * Asks the server which sign-in methods an email is registered with, so the
 * auth UI can redirect the user to the correct action instead of a dead-end
 * error. Always resolves to a hint (never throws) — it only *enriches* an
 * error that has already surfaced, so a failed lookup degrades gracefully to
 * "no hint" and the original message stands.
 */
export function useEmailAuthHint() {
  return useMutation({
    mutationKey: ['auth', 'email-hint'],
    mutationFn: (email: string): Promise<EmailAuthHint> =>
      fetchEmailAuthHint(email),
  });
}
